import { RiBookOpenLine, RiUserSearchLine } from "react-icons/ri";
import React from "react";
import { FaHiking } from "react-icons/fa";
import About from "../Pages/About";
import ProfilePage from "../Pages/Profile";
import MyTripsPage from "../Pages/MyTripsPage";
import JoinTrips from "../Pages/JoinTrips";
import RegisterForm from "../Pages/RegisterForm";

export const routes = [
    {
        path: "/",
        element: <JoinTrips />,
        buttonText: "הצטרפות לטיולים",
        icon: <RiUserSearchLine />,
        auth: true,
    },

    {
        path: "/myTrips",
        element: <MyTripsPage />,
        buttonText: "הטיולים שלי",
        icon: <FaHiking />,
        auth: true,
    },

    {
        path: "/about",
        element: <About />,
        buttonText: "עלינו",
        icon: <RiBookOpenLine />,
        auth: false,
    },

    {
        path: "/profile",
        element: <ProfilePage />,
        buttonText: null,
        icon: null,
        auth: true,
    },

    {
        path: "/register",
        element: <RegisterForm />,
        buttonText: null,
        icon: null,
        auth: false
    }
]
